export default __webpack_public_path__ + "static/media/step2_poi_image1.9575700f.jpg";